// extracted by mini-css-extract-plugin
export default {"button":"SvgButton_button__2mxT6","withColorOnFocus":"SvgButton_withColorOnFocus__C5wEV","disabled":"SvgButton_disabled__kd+Gi","label":"SvgButton_label__V8jW5"};